import { useIsMobile } from '../../hooks/useIsMobile';
import { ContactsMobile } from './ContactsMobile';
import { ContactsDesktop } from './ContactsDesktop';

/**
 * CONTATTI — la rubrica unica: clienti, potenziali, professionisti e
 * fornitori, ognuno una volta sola con le sue etichette addosso.
 *
 * Computer e telefono sono due pagine con la stessa domanda ("chi è, e come lo
 * raggiungo?"): ContactsDesktop (rubrica con la scheda accanto, ridisegnata il
 * 26/10/2026) e ContactsMobile. La pagina del computer di prima (quattro numeri,
 * tabella a sei colonne, ordina e filtra) è copiata in
 * os-planning/ridisegno/prima-del-ridisegno/lavoro.
 */
export function ContactsPage() {
  const isMobile = useIsMobile();
  return isMobile ? <div className="page"><ContactsMobile /></div> : <ContactsDesktop />;
}
